/**
 * Repositions and restyles the Camweara ring sizer app button
 * to the left of the PDP size guide for ring products only.
 */
(function () {
  'use strict';

  var INITIALIZED_CLASS = 'camweara-ring-sizer-btn--pdp';
  var HIDDEN_CLASS = 'camweara-ring-sizer-btn--hidden';
  var RELOCATED_CLASS = 'camweara-ring-sizer--relocated';
  var MAX_ATTEMPTS = 50;
  var POLL_INTERVAL = 200;
  var RING_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" ' +
    'viewBox="0 0 12 15" fill="none" aria-hidden="true">' +
    '<path d="M5.99994 4.50024C3.51838 4.50024 1.49994 6.51868 1.49994 9.00024C1.49994 11.4818 3.51838 13.5002 5.99994 13.5002C8.4815 13.5002 10.4999 11.4818 10.4999 9.00024C10.4999 6.51868 8.4815 4.50024 5.99994 4.50024ZM5.99994 13.0002C3.7945 13.0002 1.99995 11.2057 1.99995 9.00024C1.99995 6.79483 3.7945 5.00025 5.99994 5.00025C8.20538 5.00025 9.99993 6.79481 9.99993 9.00024C9.99993 11.2057 8.20538 13.0002 5.99994 13.0002Z" fill="black"/>' +
    '<path d="M8.34296 3.62312L9.22362 1.86182C9.22538 1.8583 9.22652 1.85473 9.22808 1.85121C9.23057 1.84564 9.23308 1.84011 9.23516 1.83434C9.23707 1.82912 9.2385 1.82388 9.24003 1.8186C9.24152 1.81345 9.24307 1.80832 9.24425 1.80308C9.24548 1.79757 9.24627 1.79209 9.24709 1.78661C9.24791 1.78128 9.24876 1.77598 9.24923 1.77059C9.24964 1.76566 9.24967 1.76077 9.24978 1.75588C9.24996 1.74973 9.25014 1.74363 9.24984 1.73745C9.24964 1.73373 9.24911 1.7301 9.24876 1.72644C9.24808 1.71923 9.24741 1.71205 9.24606 1.70484C9.24568 1.70288 9.24507 1.70098 9.24466 1.69901C9.24164 1.68475 9.23722 1.67063 9.23147 1.65662C9.22992 1.65281 9.22866 1.64886 9.2269 1.64511C9.22517 1.64145 9.22298 1.63787 9.22104 1.63424C9.21756 1.62759 9.21395 1.62103 9.20991 1.6147C9.20918 1.61358 9.20871 1.61241 9.20798 1.6113L8.20802 0.111328C8.16164 0.0417773 8.08359 0 8.00001 0H6H3.99999C3.91641 0 3.83833 0.0417773 3.79198 0.111328L2.79199 1.61133C2.79126 1.61244 2.79079 1.61361 2.79006 1.61473C2.78599 1.62105 2.78238 1.62765 2.7789 1.6343C2.77699 1.63793 2.77479 1.64147 2.77307 1.64514C2.77128 1.64897 2.76999 1.65302 2.76838 1.65694C2.7627 1.67083 2.7583 1.68486 2.75531 1.69901C2.7549 1.70098 2.75426 1.70288 2.75391 1.70487C2.75256 1.71205 2.75188 1.71923 2.75121 1.72641C2.75086 1.7301 2.7503 1.73376 2.75013 1.73748C2.74983 1.74363 2.75004 1.74973 2.75019 1.75585C2.7503 1.76077 2.75033 1.76566 2.75074 1.77062C2.75121 1.77598 2.75206 1.78125 2.75288 1.78655C2.7537 1.79206 2.75449 1.79757 2.75572 1.80311C2.75689 1.80835 2.75845 1.81345 2.75994 1.81857C2.76146 1.82385 2.76293 1.82912 2.76483 1.83437C2.76691 1.84008 2.76943 1.84562 2.77189 1.85115C2.77348 1.8547 2.77462 1.8583 2.77638 1.86182L3.65704 3.62312C1.46786 4.59469 0 6.65502 0 9C0 12.3137 2.68635 15 6 15C9.31365 15 12 12.3137 12 9C12 6.65502 10.5322 4.59469 8.34296 3.62312ZM7.8455 3.50001H6.90451L7.25555 2.79794L7.65451 2.00001H8.5955L7.8455 3.50001ZM6.89645 1.5H5.10357L6 0.603545L6.89645 1.5ZM5.6545 3.50001L4.9045 2.00001H7.0955L6.74446 2.70208L6.3455 3.50001H5.6545ZM7.86621 0.50001L8.53286 1.5H7.60353L6.60354 0.50001H7.86621ZM4.13379 0.50001H5.39643L4.39644 1.5H3.46711L4.13379 0.50001ZM4.34549 2.00001L4.74445 2.79794L5.09549 3.50001H4.1545L3.4045 2.00001H4.34549ZM6 14.5C2.96247 14.5 0.50001 12.0376 0.50001 9C0.50001 6.79559 1.92847 4.85818 4.04821 3.99999H5.50002H6.50001H7.95182C10.0716 4.85818 11.5 6.79559 11.5 9C11.5 12.0376 9.03753 14.5 6 14.5Z" fill="black"/>' +
    '</svg>';

  /**
   * Returns true when the product is a ring.
   *
   * @param {HTMLElement} button
   * @returns {boolean}
   */
  function isRingProduct(button) {
    if (!button) {
      return false;
    }

    var tags = button.getAttribute('data-product-tags') || '';
    var productType = button.getAttribute('data-product-type') || '';

    if (tags.indexOf('type: rings') !== -1 || productType === 'Rings') {
      return true;
    }

    if (window.Shopify && Shopify.product) {
      if (Shopify.product.type === 'Rings') {
        return true;
      }

      var shopifyTags = Shopify.product.tags || [];

      for (var i = 0; i < shopifyTags.length; i++) {
        if (shopifyTags[i].toLowerCase() === 'type: rings') {
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Hides the original app block wrapper while keeping the iframe usable.
   *
   * @param {HTMLElement|null} appBlock
   */
  function hideAppBlock(appBlock) {
    if (!appBlock) {
      return;
    }

    appBlock.classList.add('camweara-ring-sizer-app-block--hidden');
  }

  /**
   * Hides the Camweara button on non-ring products.
   *
   * @param {HTMLElement} button
   * @param {HTMLElement|null} appBlock
   */
  function hideNonRingButton(button, appBlock) {
    button.classList.add(HIDDEN_CLASS);
    button.style.display = 'none';
    hideAppBlock(appBlock);
  }

  /**
   * Replaces the default Camweara icon with the theme ring icon.
   *
   * @param {HTMLElement} button
   */
  function replaceRingIcon(button) {
    var iconWrap = button.querySelector('.camweara-icon');

    if (iconWrap) {
      iconWrap.innerHTML = RING_ICON_SVG;
    }
  }

  /**
   * Applies layout styles so CSS typography can take over.
   *
   * @param {HTMLElement} button
   */
  function restyleButton(button) {
    button.classList.add(INITIALIZED_CLASS);
    replaceRingIcon(button);
    button.style.cssText = [
      'display: flex',
      'align-items: center',
      'background: transparent',
      'border: none',
      'padding: 0',
      'margin: 0',
      'width: auto',
      'min-width: fit-content',
      'cursor: pointer',
      'color: #000',
      '--camweara-btn-align: center',
    ].join(';');
  }

  /**
   * Moves and restyles the Camweara button when present.
   *
   * @returns {boolean} True when polling can stop.
   */
  function initCamwearaRingSizer() {
    var button = document.getElementById('camweara-ring-sizer');

    if (!button) {
      return false;
    }

    if (button.classList.contains(INITIALIZED_CLASS)) {
      return true;
    }

    var appBlock = button.closest('.shopify-app-block');
    var placeholder = document.querySelector(
      '.section-product .ring-size-guide'
    );

    if (!isRingProduct(button)) {
      hideNonRingButton(button, appBlock);
      return true;
    }

    if (!placeholder) {
      return false;
    }

    restyleButton(button);
    placeholder.appendChild(button);
    placeholder.classList.add(RELOCATED_CLASS);
    button.style.display = 'flex';
    hideAppBlock(appBlock);

    if (appBlock) {
      appBlock.classList.add('camweara-ring-sizer-app-block--iframe-only');
    }

    return true;
  }

  /**
   * Polls for the app block because it may load after DOMContentLoaded.
   *
   * @param {number} attempt
   */
  function pollForButton(attempt) {
    if (initCamwearaRingSizer()) {
      return;
    }

    if (attempt >= MAX_ATTEMPTS) {
      return;
    }

    setTimeout(function () {
      pollForButton(attempt + 1);
    }, POLL_INTERVAL);
  }

  function onReady() {
    pollForButton(0);

    if (typeof MutationObserver === 'undefined') {
      return;
    }

    var observer = new MutationObserver(function () {
      initCamwearaRingSizer();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
